import { render, staticRenderFns } from "./terveyskeskuskoulutusjaksot-card.vue?vue&type=template&id=4c9b5a79&scoped=true&"
import script from "./terveyskeskuskoulutusjaksot-card.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjaksot-card.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjaksot-card.vue?vue&type=style&index=0&id=4c9b5a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b5a79",
  null
  
)

export default component.exports